import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import { getScreenWidth, generateKey } from '@/utils';
import { TABLET_L } from '@/constants';

import Slider from '../../../components/Slider/Slider';
import Image from '../../../components/ContentfulImage';

import {
  Description,
  Section,
  Slide,
  Title,
  Catchline,
  HeroImagesWrapper,
  LeftSection,
  RightSection,
  SectionUnorderedList,
  SectionListItemWrapper,
  SectionListItem,
  TopRow,
  BottomRow,
} from './StylesLooksCarousel.style';
import Markdown from '../../../components/Markdown';
import Placeholder from '../../../components/Placeholder';

const StylesLooksCarousel = ({ style, screenSize }) => (
  <Section>
    <TopRow>
      {!_.get(style, 'images') && (
        <HeroImagesWrapper>
          <Placeholder
            w={screenSize > TABLET_L ? '500px' : `${screenSize - 40}px`}
            h={screenSize > TABLET_L ? '439px' : `${screenSize - 40}px`}
          />
        </HeroImagesWrapper>
      )}
      {!!(_.get(style, 'images') && style.images.length > 0) && (
        <HeroImagesWrapper>
          {style.images.length === 1 && (
            <Image
              src={style.images[0]}
              options={{
                w: screenSize > TABLET_L ? '500px' : `${screenSize - 40}px`,
                h: screenSize > TABLET_L ? '500px' : `${screenSize - 40}px`,
                size: screenSize > TABLET_L ? [0, 0, 500, 500] : [0, 0, screenSize - 40, screenSize - 40],
                aspectRatio: 9 / 10,
                objectFit: 'cover',
                autoHeight: true,
              }}
            />
          )}
          {style.images.length > 1 && (
            <Slider
              isStylePage
              stylePageItemWidth={screenSize - 40}
              dots
              dotsStyle={{ bottom: '-60px' }}
              dotsColor="#000"
              keys={style.images.map(({ title }) => title)}
              options={{
                duration: 400,
                easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
                loop: true,
              }}
            >
              {style.images.map(image => (
                <Slide key={image.title}>
                  <Image
                    src={image}
                    options={{
                      w: screenSize > TABLET_L ? '500px' : `${screenSize - 40}px`,
                      h: screenSize > TABLET_L ? '500px' : `${screenSize - 40}px`,
                      size: screenSize > TABLET_L ? [0, 0, 500, 500] : [0, 0, screenSize - 40, screenSize - 40],
                      aspectRatio: 9 / 10,
                      objectFit: 'cover',
                    }}
                  />
                </Slide>
              ))}
            </Slider>
          )}
        </HeroImagesWrapper>
      )}
    </TopRow>

    <BottomRow isCa={style.isCa}>
      <LeftSection>
        <Title>
          {style.name || (
            <Placeholder w={screenSize > TABLET_L ? '370px' : '280px'} h={screenSize > TABLET_L ? '45px' : '24px'} />
          )}
        </Title>
        <Catchline>
          {style.catchline || (
            <Placeholder
              w={screenSize > TABLET_L ? '370px' : '100%'}
              h={screenSize > TABLET_L ? '26px' : '60px'}
              m={screenSize > TABLET_L ? null : '20px 0 20px 0'}
            />
          )}
        </Catchline>
      </LeftSection>

      <RightSection>
        {(style.notLoaded || style.colors) && (
          <SectionUnorderedList
            height={screenSize > TABLET_L ? '50px' : '43px'}
            isLoading={!_.find(style.colors, item => _.get(item, 'name'))}
          >
            {style.colors.map((color, index) => (
              <SectionListItemWrapper key={generateKey('color', index)}>
                {_.get(color, 'name') && (
                  <SectionListItem background={color.colorCode || 'white'} key={color.name || color.key}>
                    {color.name}
                  </SectionListItem>
                )}
              </SectionListItemWrapper>
            ))}
          </SectionUnorderedList>
        )}
        {style.description ? (
          <Markdown src={style.description} Component={Description} />
        ) : (
          <Placeholder w="100%" h="100px" />
        )}
      </RightSection>
    </BottomRow>
  </Section>
);

StylesLooksCarousel.defaultProps = {
  screenSize: null,
};

StylesLooksCarousel.propTypes = {
  style: PropTypes.shape({
    images: PropTypes.arrayOf(PropTypes.shape()),
    name: PropTypes.string,
    description: PropTypes.string,
    reviewImage: PropTypes.shape(),
  }).isRequired,
  // スクリーンサイズ
  screenSize: PropTypes.number,
};

const mapState = () => ({
  // スクリーンサイズを実寸で取得する
  screenSize: getScreenWidth(),
});

export default connect(mapState)(StylesLooksCarousel);



// WEBPACK FOOTER //
// ./src/pages/StylePage/StylesLooksCarousel/StylesLooksCarousel.js